import React, { useState, useEffect, useRef } from 'react';
import './Carousel.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/navigation';
import { formatAuthor } from '../../composants/utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const Carousel = ({ slides }) => {
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    if (progressCircle.current && progressContent.current) {
      progressCircle.current.style.setProperty('--progress', 1 - progress);
      progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
    }
  };


  if (!slides || slides.length === 0) {
    return null;
  }

  return (
    <>
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        loop={true}
        speed={1000}
        pagination={{ clickable: true }}
        navigation={{ clickable: true }}
        autoplay={slides.length > 1 ? {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        } : false}
        onAutoplayTimeLeft={slides.length > 1 ? onAutoplayTimeLeft : undefined}
        className="carousel">
        {slides.map((slide, index) => (
          <SwiperSlide
            key={index}
            style={{ backgroundImage: `url(${slide.cover})` }}
            className='carousel-slide active'
          >

            {
              slide.image == null ? <div className="carousel-content">
                <h1 className="animate__animated animate__fadeInDown">{slide.title}</h1>
                <p className="animate__animated animate__fadeInUp">{slide.subtitle}</p>
                {
                  slide.hasContent && (
                    <a 
                      href={`/infos/${slide.id}`} 
                      className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-orange-600 to-red-600 text-white font-bold rounded-full shadow-lg hover:shadow-orange-500/40 transform hover:-translate-y-1 hover:scale-105 transition-all duration-300 animate__animated animate__fadeInUp group mt-4"
                    >
                      <span>En savoir plus</span>
                      <FontAwesomeIcon icon={faArrowRight} className="group-hover:translate-x-1 transition-transform duration-300" />
                    </a>
                  )
                }
              </div>
                :
                <section className="min-h-screen flex items-center justify-center">
                  <div style={
                    {
                      background: 'rgba(255, 255, 255, 0.85)'
                    }
                  } className="flex flex-col md:flex-row rounded-2xl shadow-lg max-w-3xl mx-4 p-5 items-center gap-4">
                    <div className="w-full md:w-1/2 text-center md:text-left">
                      <div>
                        <h1 title={slide.title} className="animate__animated animate__fadeInDown">{formatAuthor(slide.title, 20)}</h1>
                        <p title={slide.subtitle} className="animate__animated animate__fadeInUp">{formatAuthor(slide.subtitle, 30)}</p>
                        {
                          slide.hasContent && (
                            <a 
                              href={`/infos/${slide.id}`} 
                              className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-orange-600 to-red-600 text-white font-bold rounded-full shadow-lg hover:shadow-orange-500/40 transform hover:-translate-y-1 hover:scale-105 transition-all duration-300 animate__animated animate__fadeInUp group"
                            >
                              <span>En savoir plus</span>
                              <FontAwesomeIcon icon={faArrowRight} className="group-hover:translate-x-1 transition-transform duration-300" />
                            </a>
                          )
                        }
                      </div>
                    </div>

                    <div className="hidden md:block w-full md:w-1/2">
                      <img className="rounded-2xl" src={slide.image} />
                    </div>
                  </div>
                </section>
            }

          </SwiperSlide>
        ))}
        {slides.length > 1 && <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg>
          <span ref={progressContent}></span>
        </div>
        }

      </Swiper>
    </>
  );
};

export default Carousel; 